import {Component, OnInit} from '@angular/core';
import {CustomerSupportService} from '../customer-support.service';
import {MatDialog} from '@angular/material/dialog';
import {ContactDialogComponent} from './contact-dialog/contact-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit{
    contactForms;
    paginateData: any[] = [];
    page = 1;
    pageSize = 10;
    collectionSize = 0;

    constructor(private snackBar: MatSnackBar,
                private csService: CustomerSupportService,
                public dialog: MatDialog) {
    }

    ngOnInit() {
        this.getContactForms();
    }

    changePage(){
        this.paginateData =  this.contactForms
            .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }

    getIndex(recommendationId){
        return this.contactForms.findIndex(val => val.id === recommendationId) + 1;
    }

    getContactForms(){
        this.csService.getContactForms().subscribe(contactForms =>{
            this.contactForms = contactForms;
            this.collectionSize = this.contactForms.length;
            this.changePage();
        })
    }

    viewMore(contactForm, contactFormId) {
        this.dialog.open(ContactDialogComponent, {
            data: {
                contactForm,
                contactFormId
            }
        });
    }

    deleteContactForm(contactForm, contactFormId) {
        if(confirm(`Sigur doresti sa stergi mesajul de la ${contactForm.name}`)) {
            this.csService.deleteContactForm(contactForm.id).subscribe(contactFormDeleted => {
                if(contactFormDeleted){
                    this.getContactForms();
                    this.snackBar.open('Cerere stearsa cu succes', 'Ok', {
                        duration: 2000,
                    })
                }else{
                    this.snackBar.open('Cererea nu a putut fi stearsa', 'Ok', {
                        duration: 2000,
                    })
                }
            })
        }
    }
}
